import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiRecalculateToningData(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/recaculatetoningdata`, data);
}
